export default defineAppConfig({
	ui: {
		colors: {
			primary: 'amber',
			neutral: 'slate',
		},
		container: {
			base: 'max-w-[1536px] w-full px-4 sm:px-6 lg:px-14',
		},
		button: {
			slots: {
				base: 'disabled:opacity-50',
			},
			defaultVariants: {
				size: 'lg',
			},
		},
		input: {
			slots: {
				root: 'w-full',
				base: 'read-only:not-disabled:bg-elevated/50',
			},
			defaultVariants: {
				size: 'lg',
			},
		},
		selectMenu: {
			defaultVariants: {
				size: 'lg',
			},
		},
		select: {
			defaultVariants: {
				size: 'lg',
			},
		},
		pinInput: {
			variants: {
				size: {
					md: {
						base: 'h-12 md:size-12 text-xl',
					},
				},
			},
		},
		textarea: {
			slots: {
				root: 'w-full',
				base: 'read-only:not-disabled:bg-elevated/50',
			},
		},
		badge: {
			variants: {
				size: {
					// lg at the height of an md button
					'lg-tall': {
						base: 'text-sm px-2 py-1 gap-1.5 rounded-md h-8',
						leadingIcon: 'size-5',
						leadingAvatarSize: '2xs',
						trailingIcon: 'size-5',
					},
				},
			},
		},
		card: {
			variants: {
				variant: {
					outline: {
						root: 'shadow-sm',
					},
				},
			},
		},
		tabs: {
			compoundVariants: [
				{
					color: 'neutral',
					class: {
						trigger: 'data-[state=active]:text-default',
						indicator: 'bg-default',
					},
				},
			],
		},
		avatar: {
			variants: {
				size: {
					'2xl': {
						root: 'size-16',
					},
					'3xl': {
						root: 'size-20',
					},
				},
			},
		},
	},
});
